// Brand & content data for ADI FOUNDATION

export const BRAND = {
  name: 'ADI FOUNDATION',
  tagline: 'Nar Sewa Narayan Sewa',
  taglineHi: 'नर सेवा नारायण सेवा',
  taglineMeaning: 'Service to Humanity is Service to the Divine',
  foundedYear: '2024',
  foundedSeason: 'Winter',
  phone: '+91 9990888532',
  phoneHref: 'tel:+919990888532',
  whatsappHref: 'https://wa.me/919990888532',
  email: 'info@adifoundation.in',
  emailHref: 'mailto:info@adifoundation.in',
  presence: ['Delhi', 'Lucknow', 'Nagpur'],
  reachLine: 'Operating Across India',
  logo: 'https://customer-assets.emergentagent.com/job_a2ebe318-d51a-454c-97c0-0d0f8b8660d2/artifacts/mjp1epjt_ADI%20Logo.png',
  social: {
    instagram: '#',
    facebook: '#',
    twitter: '#',
    youtube: '#',
    linkedin: '#',
  },
};

export const NAV_LINKS = [
  { label: 'About', href: '#about' },
  { label: 'Causes', href: '#causes' },
  { label: 'Impact', href: '#impact' },
  { label: 'Gallery', href: '#gallery' },
  { label: 'Events', href: '#events' },
  { label: 'FAQ', href: '#faq' },
  { label: 'Contact', href: '#contact' },
];

export const STATS = [
  { value: 50000, suffix: '+', label: 'Meals Distributed', sub: 'Across 14 states' },
  { value: 2500, suffix: '+', label: 'Families Supported', sub: 'Through monthly programs' },
  { value: 850, suffix: '+', label: 'Volunteers', sub: 'On-ground & remote' },
  { value: 18, suffix: '', label: 'Cities Reached', sub: 'And growing every quarter' },
];

export const CAUSES = [
  {
    id: 'education',
    title: 'Education for Children',
    short: 'Books, fees and digital tools for first-generation learners.',
    icon: 'GraduationCap',
    image:
      'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=900&q=80&auto=format&fit=crop',
  },
  {
    id: 'food',
    title: 'Food & Hunger Relief',
    short: 'Hot meals, ration kits and community kitchens for the unseen hungry.',
    icon: 'UtensilsCrossed',
    image:
      'https://images.unsplash.com/photo-1578357078586-491adf1aa5ba?w=900&q=80&auto=format&fit=crop',
  },
  {
    id: 'marriage',
    title: 'Vivah Sahayata',
    short:
      'Honourable wedding support for daughters of underprivileged families — trousseau, rituals & dignity.',
    icon: 'Heart',
    image:
      'https://images.unsplash.com/photo-1597157639073-69284dc0fdaf?w=900&q=80&auto=format&fit=crop',
  },
  {
    id: 'healthcare',
    title: 'Healthcare Camps',
    short: 'Free check-ups, medicines and awareness drives in remote villages.',
    icon: 'Stethoscope',
    image:
      'https://images.unsplash.com/photo-1698465281093-9f09159733b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxtZWRpY2FsJTIwY2FtcCUyMGRvY3RvciUyMGluZGlhJTIwcnVyYWx8ZW58MHx8fHwxNzc4MjQyMTY2fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'environment',
    title: 'Environmental Protection',
    short: 'Native tree plantation, river cleaning and climate awareness.',
    icon: 'Leaf',
    image:
      'https://images.unsplash.com/photo-1708592953226-11ad725adc75?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwzfHxlbnZpcm9ubWVudCUyMHRyZWUlMjBwbGFudGF0aW9uJTIwaW5kaWF8ZW58MHx8fHwxNzc4MjQyMTgxfDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'rural',
    title: 'Rural Development',
    short: 'Clean water, sanitation and livelihood projects in 200+ villages.',
    icon: 'Sprout',
    image:
      'https://images.unsplash.com/photo-1596450514537-fae68a81346b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxuZ28lMjB2b2x1bnRlZXIlMjB0ZWFtd29yayUyMGluZGlhfGVufDB8fHx8MTc3ODI0MjE4MXww&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'animals',
    title: 'Animal Welfare',
    short: 'Care, feeding and rescue of stray and abandoned animals.',
    icon: 'PawPrint',
    image:
      'https://images.unsplash.com/photo-1560493676-04071c5f467b?w=900&q=80&auto=format&fit=crop',
  },
  {
    id: 'women',
    title: 'Women Empowerment',
    short: 'Skills training, livelihood support and dignity for women across rural India.',
    icon: 'Users',
    image:
      'https://images.unsplash.com/photo-1601597111158-2fceff292cdc?w=900&q=80&auto=format&fit=crop',
  },
];

export const VALUES = [
  {
    title: 'Compassion',
    text: 'Every soul we touch is met with quiet dignity, never charity.',
    icon: 'Heart',
  },
  {
    title: 'Transparency',
    text: 'Open books, audited reports and traceable impact for every rupee.',
    icon: 'ShieldCheck',
  },
  {
    title: 'Seva',
    text: 'Selfless service rooted in our heritage of "Nar Sewa Narayan Sewa".',
    icon: 'Sparkles',
  },
  {
    title: 'Local first',
    text: 'Empowering community leaders to lead change in their own land.',
    icon: 'Users',
  },
];

export const TESTIMONIALS = [];


export const EVENTS = [
  {
    date: '15 Jun 2026',
    title: 'Monsoon Relief Kit Drive — Delhi NCR',
    desc: 'Raincoats, tarpaulins and dry rations for 500 pavement-dweller families.',
    tag: 'Upcoming',
    image:
      'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=900&q=80&auto=format&fit=crop',
  },
  {
    date: '15 Aug 2026',
    title: 'Independence Day Health Camp — Lucknow',
    desc: 'Free general check-up, eye and dental clinic for slum communities.',
    tag: 'Upcoming',
    image:
      'https://images.unsplash.com/photo-1582719471384-894fbb16e074?w=900&q=80&auto=format&fit=crop',
  },
  {
    date: '05 Sep 2026',
    title: 'Teachers Day School Kit Drive — Nagpur',
    desc: 'Notebooks, slates and uniforms for 600 children at three village schools.',
    tag: 'Upcoming',
    image:
      'https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=900&q=80&auto=format&fit=crop',
  },
  {
    date: '02 Oct 2026',
    title: 'Gandhi Jayanti Cleanliness Drive — Pan-India',
    desc: 'Village sanitation and clean water awareness campaign across multiple states.',
    tag: 'Campaign',
    image:
      'https://images.unsplash.com/photo-1532629345422-7515f3d16bb6?w=900&q=80&auto=format&fit=crop',
  },
];

export const BLOG = [
  {
    title: 'Why hot meals matter more than ration kits',
    excerpt:
      'Reflections from our community kitchens on dignity, taste and the quiet politics of feeding strangers.',
    date: '02 Nov 2025',
    image:
      'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=900&q=80&auto=format&fit=crop',
    readTime: '6 min read',
  },
  {
    title: 'A teacher in every village: our 2026 commitment',
    excerpt:
      'How Adi Foundation is partnering with local panchayats to place a trained educator in every served village.',
    date: '21 Oct 2025',
    image:
      'https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=900&q=80&auto=format&fit=crop',
    readTime: '8 min read',
  },
  {
    title: 'After the floods: rebuilding Bihar, one home at a time',
    excerpt:
      'Field notes from Madhubani — what aid looks like when the cameras leave and the cleanup begins.',
    date: '14 Sep 2025',
    image:
      'https://images.unsplash.com/photo-1469571486292-0ba58a3f068b?w=900&q=80&auto=format&fit=crop',
    readTime: '11 min read',
  },
];

export const FAQS = [
  {
    q: 'How does Adi Foundation use the funds it receives?',
    a: 'Approximately 88 paise of every rupee goes directly to programs (food, education, healthcare, livelihoods). The remaining 12 paise covers compliance, audit and operational costs. Annual audited reports are published openly.',
  },
  {
    q: 'Is my donation tax-deductible?',
    a: 'Yes — donations to ADI FOUNDATION are eligible for benefits under Section 80G of the Income Tax Act, 1961, in India. A digital receipt is issued for every contribution.',
  },
  {
    q: 'How can I become a volunteer?',
    a: 'Use the Volunteer form on this site. We have on-ground roles (food kitchens, health camps, teaching) and remote roles (design, content, fundraising, mentoring). We onboard new volunteers every fortnight.',
  },
  {
    q: 'Do you operate only in Delhi, Lucknow and Nagpur?',
    a: 'Those are our core city offices. However, Adi Foundation operates field programs across India — including Bihar, Uttar Pradesh, Madhya Pradesh, Maharashtra, Odisha, Jharkhand and the North-East — through partner volunteers and seasonal camps.',
  },
  {
    q: 'Can companies partner under CSR?',
    a: 'Absolutely. We are a registered non-profit eligible for CSR partnerships under the Companies Act. Write to us at info@adifoundation.in for our impact deck and program portfolio.',
  },
  {
    q: 'How do I know my donation has actually reached someone?',
    a: 'Each program publishes monthly field reports with photographs, beneficiary stories and geo-tagged distribution data. Recurring donors receive a personalised quarterly impact email.',
  },
];

export const GALLERY = [
  {
    src: 'https://images.unsplash.com/photo-1503676382389-4809596d5290?w=900&q=80&auto=format&fit=crop',
    alt: 'Children smiling at a community education center',
    span: 'tall',
  },
  {
    src: 'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=900&q=80&auto=format&fit=crop',
    alt: 'Volunteer serving a hot meal to an elderly woman',
    span: 'wide',
  },
  {
    src: 'https://images.unsplash.com/photo-1469571486292-0ba58a3f068b?w=900&q=80&auto=format&fit=crop',
    alt: 'Plantation drive at dawn',
    span: 'normal',
  },
  {
    src: 'https://images.unsplash.com/photo-1469571486292-0ba58a3f068b?w=900&q=80&auto=format&fit=crop',
    alt: 'Kids learning under a tree',
    span: 'normal',
  },
  {
    src: 'https://images.pexels.com/photos/15815339/pexels-photo-15815339.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    alt: 'Women at a tailoring training session',
    span: 'tall',
  },
  {
    src: 'https://images.unsplash.com/photo-1591456983933-0c2bdfb20457?w=900&q=80&auto=format&fit=crop',
    alt: 'Doctor examining patient at rural camp',
    span: 'normal',
  },
  {
    src: 'https://images.unsplash.com/photo-1532629345422-7515f3d16bb6?w=900&q=80&auto=format&fit=crop',
    alt: 'Volunteers carrying ration kits',
    span: 'wide',
  },
  {
    src: 'https://images.unsplash.com/photo-1542838132-92c53300491e?w=900&q=80&auto=format&fit=crop',
    alt: 'Distributing books to children',
    span: 'normal',
  },
];

// Indian states represented as approximate (x, y) percentages on a stylised India outline.
// We use this to drop pulsing markers for our active cities.
export const ACTIVE_CITIES = [
  { name: 'Delhi', x: 35, y: 32, primary: true, note: 'HQ & North Operations' },
  { name: 'Lucknow', x: 47, y: 36, primary: true, note: 'UP & Bihar Programs' },
  { name: 'Nagpur', x: 45, y: 56, primary: true, note: 'Central India Hub' },
  { name: 'Mumbai', x: 28, y: 60 },
  { name: 'Kolkata', x: 67, y: 47 },
  { name: 'Bengaluru', x: 38, y: 76 },
  { name: 'Patna', x: 58, y: 41 },
  { name: 'Bhopal', x: 41, y: 48 },
  { name: 'Guwahati', x: 78, y: 38 },
];

export const DONATE_TIERS = [
  { amount: '₹500', label: 'Feed a family for a week', impact: '21 hot meals' },
  { amount: '₹1,500', label: 'Educate a child for a month', impact: 'Books + tuition' },
  { amount: '₹3,000', label: 'Sponsor a health camp seat', impact: 'Doctor + medicines' },
  { amount: '₹10,000', label: 'Empower a Vivah Sahayata trousseau', impact: 'Sari, rituals, dignity' },
];
